import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { IEditDefaultPricicingPocRequest } from "@shared/lib/types/brief";
import { BriefService } from "../services/brief.service";
import { setBriefByIdQueryData } from "./useGetBriefById";

export function useEditDefaultAgencyPricingPoc() {
  const {
    mutate: editDefaultAgencyPricingPoc,
    isLoading: isEditingDefaultAgencyPricingPoc,
    isSuccess: isEditedDefaultAgencyPricingPoc,
  } = useMutation({
    mutationFn: (data: IEditDefaultPricicingPocRequest) =>
      BriefService.editDefaultAgecnyPricicingPoc(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: { skipInvalidation: true },
    onSuccess: (queryClient, response, variables) => {
      setBriefByIdQueryData(queryClient, variables.briefId, response);
      ToastService.success("Default agency pricing POC updated successfully");
    },
  });

  return {
    editDefaultAgencyPricingPoc,
    isEditingDefaultAgencyPricingPoc,
    isEditedDefaultAgencyPricingPoc,
  };
}
